/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentProject_ProjectJobs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Project Job API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Thursday, June 27, 2019 - 12:00:28 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      06/27/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Project_ProjectJobs = {
    all: (companyid, projectid, parentid, jobtypeid, sourceid, assignedid, priorityid, severityid, statusid, versionfoundid, versiontargetid, versionfixedid, audituserid) =>
        requests.get(`/ProjectJobs?companyid=${companyid}&projectid=${projectid}&parentid=${parentid}&jobtypeid=${jobtypeid}`
        + `&sourceid=${sourceid}&assignedid=${assignedid}&priorityid=${priorityid}&severityid=${severityid}&statusid=${statusid}`
        + `&versionfoundid=${versionfoundid}&versiontargetid=${versiontargetid}&versionfixedid=${versionfixedid}&audituserid=${audituserid}`),
    get: jobid => requests.get(`/ProjectJob/${jobid}`),
    create: projectjob => requests.post(`/ProjectJobs`, projectjob),
    update: (jobid, projectjob) => requests.put(`/ProjectJob/${jobid}`, projectjob),
    delete: jobid => requests.del(`/ProjectJob/${jobid}`),
};